import { Component } from "@angular/core";

@Component({
  selector: "x-social-svg",
  templateUrl: "./x-social.component.svg"
})
export class XSocialSvgComponent { }
